import * as format from '../data/format';
import datetime from './datetime';

/**
 * Processes and optimizes the chart data before building categories and series.
 */
export default function processData(options) {
  if (options.categoriesAreDates) {
    options.dates = datetime.parse(options.categories, options);
    options.datesAll = datetime.all(options.dates);
    if ((!options.quarterlyResults || (options.quarterlyResults && options.series[0].data.length > 44)) && options.type !== 'bar') {
      options.series = insertDates(options.series, options);
    }
  }
  if (options.type === 'pie' && options.optimizeDataOrder) {
    options = optimizePieData(options);
  } else if (options.categoriesAreDates && ((!options.quarterlyResults || (options.quarterlyResults && options.series[0].data.length > 44)))) {
    options = sortDataByDate(options);
  }
  if (options.axes && options.axes.units && options.axes.units.divisor !== "none") {
    options = divideYAxisValues(options);
  }
  return options;
}

// Insert date values into all data.
function insertDates(data, options) {
  const proxyYears = getProxyYears(options);
  data.forEach(series => {
    series.data.forEach((item, index) => {
      let dateObj = options.dates[index];
      let date = new Date(dateObj.value);
      if (dateObj.year === undefined && proxyYears[index] !== undefined) {
        dateObj.yearIsProxy = true;
        date.setUTCFullYear(proxyYears[index]);
      }
      item.x = date.valueOf();
    });
  });
  return data;
}


// For data with dates with months but not years, create proxy years so the
// dates can be sorted correctly.
function getProxyYears(options) {
  let proxyYears = [];
  if (options.datesAll.month && !options.datesAll.year) {
    let year = (new Date()).getUTCFullYear();
    let month = undefined;
    for (let i = options.dates.length - 1; i >= 0; i--) {
      if (month !== undefined && month <= options.dates[i].month) {
        year -= 1;
      }
      proxyYears[i] = year;
      month = options.dates[i].month;
    }
  }
  return proxyYears;
}

function sortDataByDate(options) {
  options.series.forEach(item => {
    item.data.forEach((pt, index) => {
      pt.index = index;
    });
    if (item.data.every(point => point.x)) {
      item.data.sort((a, b) => {
        // if (a.x === undefined || b.x === undefined) {
        //   return 0;
        // }
        return a.x - b.x;
      });
    }
    // item.data.forEach((pt, index) => {
      // pt.index = index;
    // });
  });
  return options;
}

// Data should be ordered like so:
//      2 1
//    3     10
//  4         9
//    5     8
//      6 7
// Also, category names get attached to points.
function optimizePieData(options) {
  if (Array.isArray(options.categories)) {
    // Link each point to a category.
    options.series[0].data.forEach((point, index) => {
      point.name = options.categories[index];
      point.originalIndex = index;
    });
  }
  // Sort the data smallest to largest.
  options.series[0].data.sort(function (a, b) {
    if (a.y > b.y) {
      return 1;
    } else if (a.y < b.y) {
      return -1;
    }
    return 0;
  });
  // Take the largest data at the end and make it first.
  options.series[0].data.unshift(options.series[0].data.pop());
  return options;
}

function divideYAxisValues(options) {
  const divisor = format.getDivisor(options.axes.units.divisor);
  for (let i = 0; i < options.series.length; i++) {
    const yAxisValue = options.series[i].data;
    yAxisValue.forEach((value) =>{
      if (value.y === null) {
        value.y = '-';
      } else {
        value.y = value.y / divisor;
      }
    });
  }
  return options;
}



// WEBPACK FOOTER //
// ./src/chart/data/processData.js